import { italic as italic_1 } from './italic.locstring.json';
import loc from 'owa-localize';
import RibbonButton, { RibbonButtonState } from './RibbonButton';

import { toggleItalic } from 'roosterjs-editor-api';

const italic: RibbonButton = {
    key: 'italic',
    title: () => loc(italic_1),
    imageSrc: require('../svg/italic.svg'),
    shortcut: 'ctrl+I',
    buttonState: formatState =>
        formatState.isItalic ? RibbonButtonState.Checked : RibbonButtonState.Normal,
    onExecute: plugin => toggleItalic(plugin.getEditor()),
};

export default italic;
